import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SePlatformModule, SeSharedModule } from '@se/platform';
import { AddExamComponent } from './add-exam/add-exam.component';
import { MergeExamComponent } from './merge-exam/merge-exam.component';
import { ObscuredDataComponent } from './obscured-data/obscured-data.component';
import { PatientCertificationComponent } from './patient-certification/patient-certification.component';
import { RemoveExamComponent } from './remove-exam/remove-exam.component';
import { ImportGridComponent } from './import-grid/import-grid.component';
import { SuspendExamComponent } from './suspend-exam/suspend-exam.component';
import { SeFloatingLabelComponent } from './se-floating-label/se-floating-label.component';

@NgModule({
    imports: [TranslateModule, SePlatformModule, SeSharedModule],
    declarations: [
        AddExamComponent,
        ImportGridComponent,
        MergeExamComponent,
        ObscuredDataComponent,
        PatientCertificationComponent,
        RemoveExamComponent,
        SuspendExamComponent,
        SeFloatingLabelComponent,
    ],
    exports: [
        AddExamComponent,
        MergeExamComponent,
        ObscuredDataComponent,
        PatientCertificationComponent,
        RemoveExamComponent,
        SeFloatingLabelComponent,
        SuspendExamComponent,
    ],
})
export class SeComponentsModule {}
